import React from "react";
import Layout from "../components/Layout";
import Box from "../components/Box";
import Link from "../components/Link";
import Banner from "../components/Banner";
import Head from "../components/Head";
import { Labs } from "./../data/SEO";

const PageLabs = () => {
  const title = Labs[0].title;
  const description = Labs[0].description;

  return (
    <Layout>
      <Head Title={Labs[0].title} Description={Labs[0].description} />

      <Banner
        Title={
          <>
            Laboratorio
            <br />
            de Innovación
          </>
        }
        SubTitle="Nuestros proyectos propios"
        Image="assets/images/banner/labs.png"
      />

      <div className="container py-lg-5">
        <div className="row align-items-center py-5">
          <div className="col-lg-5">
            <div className="mb-4">
              <img
                src={"assets/images/emite.png"}
                height="80"
                alt="Facturación electrónica Emite"
              />
            </div>
            <p>
              <strong>
                Solución online de gestión y facturación electrónica
              </strong>
              que reduce y simplifica los proceso de toma de decisiones. Además,
              de ofrecer un control absoluto de los procesos de su negocio.
            </p>
            <div className="mt-3 pb-4 pb-lg-0">
              <Link
                Url="#"
                Class="btn-primary-outline"
                Icon="fa-external-link-alt"
                Name="Ver página"
              />
            </div>
          </div>
          <div className="col-lg-7">
            <div className="position-relative">
              <div className="text-right">
                <img src={"assets/images/labs/1.png"} alt="" />
              </div>

              <Box Image="assets/images/labs/1-image.png" Alt="Facturación" />
            </div>
          </div>
        </div>

        <div className="row flex-row-reverse align-items-center py-lg-5">
          <div className="col-lg-5">
            <div className="pl-lg-3">
              <div className="mb-4">
                <img
                  src={"assets/images/azu.png"}
                  height="100"
                  alt="Azu! App"
                />
              </div>
              <p>
                <strong>
                  En AZU! tienes una gran variedad de exquisitos menús
                </strong>
                . Realiza tus pedidos en pocos pasos, paga online o en efectivo
                y haz el seguimiento de tu orden. Disponible en App Store y Play
                Store
              </p>
              <div className="mt-3 pb-4 pb-lg-0">
                <Link
                  Url="#"
                  Class="btn-primary-outline"
                  Icon="fa-external-link-alt"
                  Name="Ver página"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="position-relative">
              <img src={"assets/images/labs/2.png"} alt="" />

              <Box
                Image="assets/images/labs/2-image.png"
                Alt="Uso de aplicativo"
                Align="box-info--right"
              />
            </div>
          </div>
        </div>

        <div className="row align-items-center py-5">
          <div className="col-lg-5">
            <div className="mb-4">
              <img src={"assets/images/erp.png"} height="80" alt="ERP" />
            </div>
            <p>
              Dotará a tu negocio de más visibilidad y te ayudará a gestionar
              todas sus operaciones en un solo lugar, pensado para cualquier
              tamaño de empresa desde pyme, mediana y grandes negocios.
            </p>
            <div className="mt-3 pb-4 pb-lg-0">
              <Link
                Url="#"
                Class="btn-primary-outline"
                Icon="fa-external-link-alt"
                Name="Ver página"
              />
            </div>
          </div>
          <div className="col-lg-7">
            <div className="position-relative">
              <div className="text-right">
                <img src={"assets/images/labs/3.png"} alt="" />
              </div>

              <Box
                Image="assets/images/labs/3-image.png"
                Alt="Mapa conceptual"
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PageLabs;
